import Video from './component';

export default Video;
